exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3_o-4q5St8Zy3cxyyw5PtB {\n  stroke-width: 1px;\n  stroke: #1F3568;\n  shape-rendering: crispedges;\n  stroke-opacity: .2;\n}\n._3Y_512P_M5lMAodTJbLWYZ {\n}\n\n._3g0PMyipMxsZ88rMG5YvKN {\n}\n._2PO4fy0M63hy2b-a4LLh0x {\n  stroke-opacity: .6;\n}\n._1ZbF8ZLalfkbhJwaTEcU6b {\n}\n._1RjHYkSahZ5ZF5Y9UXDNvu {\n}\n", ""]);

// exports
exports.locals = {
	"gridRed": "#AE1E08",
	"waveformBlack": "#3D2525",
	"light-grey": "#DCDCDC",
	"kardiaGreen": "#6BC077",
	"dark-grey": "#9E9C9C",
	"idtf-blue": "#1F3568",
	"grid": "_3_o-4q5St8Zy3cxyyw5PtB",
	"xGridSmall": "_3Y_512P_M5lMAodTJbLWYZ _3_o-4q5St8Zy3cxyyw5PtB",
	"xGrid": "_3g0PMyipMxsZ88rMG5YvKN _3_o-4q5St8Zy3cxyyw5PtB",
	"xGridDark": "_2PO4fy0M63hy2b-a4LLh0x _3_o-4q5St8Zy3cxyyw5PtB",
	"yGrid": "_1ZbF8ZLalfkbhJwaTEcU6b _3_o-4q5St8Zy3cxyyw5PtB",
	"yGridDark": "_1RjHYkSahZ5ZF5Y9UXDNvu _3_o-4q5St8Zy3cxyyw5PtB"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/views/pages/Annotation/components/FullECGPreview/Grid/Grid.css
// module id = 8719
// module chunks = 23